import { render, staticRenderFns } from "./WdfStudentInformation.vue?vue&type=template&id=1b915e20"
import script from "./WdfStudentInformation.vue?vue&type=script&lang=js"
export * from "./WdfStudentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports